import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import * as Sentry from "@sentry/react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import config from "./config";
import { PostHogProvider } from "posthog-js/react";
import { DarkModeProvider } from "./contexts/DarkModeContext"; // Assuming you have exported the DarkModeProvider from DarkModeContext.tsx
import { BrowserRouter as Router } from "react-router-dom";
import initDataDogRUM from "./instrumentation/ddrum";
import FrontendTracer from "./instrumentation/otel";
import { ThemeProvider } from "contexts/ThemeContext";
import { QueryClientProvider } from "@tanstack/react-query";
import KasContextProvider from "contexts/KasContext";
import {
  getInitialPostHogCookieConsentOptions,
  initializePostHogCookieConsentBridge,
} from "utils/posthogEventUtils";
import { queryClient } from "queryClient";

const postHogOptions: Parameters<typeof PostHogProvider>[0]["options"] = {
  api_host: "https://app.posthog.com",
  ui_host: "https://us.posthog.com",
  ...getInitialPostHogCookieConsentOptions(),
  loaded: (ph) => {
    initializePostHogCookieConsentBridge(ph);
  },
};

if (config.stage === "prod") {
  window.console.log = (): void => {};
  Sentry.init({
    dsn: "https://6d07dc60d21247b49f798d30d8963774@o410659.ingest.sentry.io/5284832",
  });
  postHogOptions.api_host = `${window.location.origin}/i`;
  initDataDogRUM(config);
} else {
  // TODO: make this more opt-in or disable after some failures.
  if (typeof window !== "undefined") FrontendTracer();
}

console.log("🤙🤙");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_POSTHOG_PROJECT_TOKEN}
      options={postHogOptions}
    >
      <ThemeProvider>
        <DarkModeProvider>
          <Router>
            <QueryClientProvider client={queryClient}>
              <KasContextProvider>
                <App />
              </KasContextProvider>
            </QueryClientProvider>
          </Router>
        </DarkModeProvider>
      </ThemeProvider>
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
